export default "__VITE_ASSET__Csy6EmeK__"